import { Card, Col, Row, Modal, Button, Layout } from 'antd';
import React from 'react';
import { createUseStyles } from 'react-jss';
import "react-lightbox-pack/dist/index.css";
import Icofont from 'react-icofont';
import { Action, useAuth } from 'fennec-ui'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { CollectionServer } from 'fennec-ui';
import { deleteInArray, errorCatch, GET } from 'fennec-ui';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { access } from '../../../common/Tool';
import { useSelector } from 'react-redux';
import PageLayout from '../../components/PageLayout';

dayjs.locale('ru');

const useStyles = createUseStyles({
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 10px",
		display: "flex",
		cursor: "pointer",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .ant-collapse-content > .ant-collapse-content-box': {
			padding: "6px"
		},
		'&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
			paddingTop: "0px",
			paddingBottom: "0px"
		}
	}
})

export default function AdminMainResourceLocks(props) {
	const classes = useStyles();
	const auth = useAuth();
	const [resourceLocksConfig, setResourceLocksConfig] = React.useState("allow")
	const role_by_id = useSelector(state => state.home.role_by_id);

	React.useEffect(() => {
		GET(auth, "/api/config/bykey?key=resource-locks",
			({ data }) => {
				if (data && data.ID) {
					setResourceLocksConfig(data.value)
				}
			}, errorCatch
		);
	}, [])

	const filters = () => [
		{
			name: "name",
			sort: true,
			filter: true,
		},
		{
			name: "uidlock",
			sort: true,
			filter: true,
		},
		{
			name: "progress",
			filterType: "range",
			func: ["min", "max"],
			sort: true,
			filter: true,
		}
	];
	const title = () => (<div style={{
		color: "rgba(0, 0, 0, 0.85)",
		fontWeight: "500",
		fontSize: "16px"
	}}>
		Блокировки
	</div>);
	const render = (item, idx) =>
	(<div key={idx} style={{ width: "100%" }}>
		<Action
			auth={auth}
			action={() => {
				// console.log(values, unlock, close); 
			}}
			object={item} // блокировка
			modal={{
				width: "750px",
				title: "Блокировка " + item.name + "-" + item.uidlock
			}}

			readonly={true}
			mode={"func"}
			noAntForm={true}
			// form={ZakazPreview}
			trigger={() => (
				<div style={{ flex: "auto" }}>
					<div style={{ fontWeight: "500" }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<div>
								<span style={{ fontStyle: "italic", color: "rgba(0, 0, 0, 0.69)" }}>Идентификатор</span>:
								{item.name}{(item.uidlock) && <span> (<span style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.55)" }}>uidlock</span>: {item.uidlock})</span>}
							</div>
							<div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div>
						</div>
					</div>
					<div style={{ fontWeight: "500" }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							{(item.message) && <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.55)" }}>
								Описание: {item.message}
							</div>}
						</div>
					</div>
					<div style={{ fontWeight: "500" }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.55)" }}>
								Установлена: {dayjs(item.CreatedAt).format('DD.MM.YYYY HH:mm:ss')}
							</div>
						</div>
					</div>
					{(item.progress) && <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.55)" }}>
						Прогресс выполнения: {item.progress}%
					</div>}
				</div>
			)}
		/>
	</div>)
	const emptyArray = () => [];
	if (!access({ role: [{ "ID": 28, "nazvanie": "СуперАдмин" }] }, role_by_id)) {
		return (<div></div>)
	}
	return (
		<PageLayout>
			<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
				<div style={{ padding: "10px" }}>
					<div>
						{(!resourceLocksConfig || resourceLocksConfig == "allow") && <div>
							<Icofont icon="check" style={{ color: "green" }} /> <span style={{ paddingRight: "3px" }}>Блокировки разрешены </span>
							<Button
								danger
								size="small"
								type="dashed"
								onClick={() => {
									GET(auth, "/api/config/SetResourceLocks/deny",
										({ data }) => {
											if (data && data.ID) {
												setResourceLocksConfig(data.value)
											}
										}, errorCatch
									);
								}}>Запретить</Button></div>}
						{(resourceLocksConfig == "deny") && <div>
							<Icofont icon="close-circled" style={{ color: "red" }} /> <span style={{ paddingRight: "3px" }}>Блокировки запрещены </span>
							<Button
								size="small"
								type="primary"
								onClick={() => {
									GET(auth, "/api/config/SetResourceLocks/allow",
										({ data }) => {
											if (data && data.ID) {
												setResourceLocksConfig(data.value)
											}
										}, errorCatch
									);
								}}>Разрешить</Button></div>}
					</div>
					<CollectionServer
						auth={auth}
						name={"ResourceLocks"}
						source={"/api/query/resourcelocks"}

						filters={filters}

						size={"small"}
						mode={"list"}
						titleFunc={title}
						render={render}

						collectionActions={emptyArray}
						modelActions={(item) => [
							{
								title: "Снять блокировку",
								action: (values, unlock, close, { collection, setCollection }) => {

									Modal.confirm({
										title: 'Снятие блокировки',
										icon: <ExclamationCircleOutlined />,
										content: 'Вы действительно хотите снять блокировку?',
										okText: "Да",
										cancelText: "Нет",
										onOk() {
											GET(auth, '/api/query-delete/resourcelocks/' + item.ID,
												() => setCollection(deleteInArray(collection, item)), errorCatch
											);
										},
										onCancel() {
										},
									});

								},
							}
						]}
					/>
				</div>
			</div>
		</PageLayout>
	);
}
